// extracted by mini-css-extract-plugin
export default {"root":"InfoMessage_root__JRMH8"};